/*
 Author: Vaishnavi
 Date: 18/11/2019
 Issue Description: Visual Bug fixes assigned by Harshvardhan Kore & Tarun Bhandari, <upload-image /> tag added (line no. 104)
 */
 /*
 Author: Srinivas P
 Date: 05/12/2019
 Issue Description: When clicked on Add New Legal Entity in Profile Icon,there is Update button instead of Save Button PL-1989
 SearchString: editForm
 */

/*
Author: Vinod
Date: 23/12/2019
Issue Description: LWF deduction frequency.
search_string: PL_2342
*/

/*
Author: Vinod
Date: 08/01/2020
Issue Description: text change in LWF Pincode alert message.
search_string: PL_2380
*/

/*
Author: Vinod
Date: 04/03/2020
Issue Description: When unchecked the Generate Automatically check box and updated, then next came to same legal entity checked the Generate Automatically check box it is showing the previous employee code in preview.
search_string: PL_2895
*/

/*
Author: Shivakumar
Date: 06/03/2020
Issue Description: LE Activation date should be on or after LE incorporation date
search_string: PL_2905
*/

/*
Author: Vinod
Date: 17/03/2020
Issue Description: Uploaded legal entity logo, Same image is displaying in Employee Code Preview
search_string: PL_2948
*/

/*
Author: Shivakumar
Date: 26/03/2020
Issue Description: [Legal Entity] While updating Organisation and Legal Entity Getting error message " parameter validation error
search_string: PL_2984
*/


<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>
        <span>{{this.leData.legalName ? this.leData.legalName :'Legal Entity'}}</span>
      </div>
      <template slot="icon">
        <div class="showIntro">
          <img src="@/assets/questionmark.png" />
        </div>
      </template>
    </tl-header>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission || ifSuperAdmin)">
      You have only view permission.
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <pop-up-message
      popupHeaderMessage="Success"
      v-if="showpopup"
      :popupType="'Success'"
      :message="popupTitle"
      class="popupClass"
    >
      <!-- Author: Vaishnavi
    Date: 10/12/2019
      Issue Description: Consistent buttons across application-->
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Go to Org Summary" type="secondary" @click="goToOrgSummary" />
          <popup-btn text="Continue Onboarding" type="primary" @click="continueToLocations" />
        </btn-grp>
      </template>
    </pop-up-message>
    <div class="row"  :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="col-12 margin-b-m">
        <span class="input-label">Logo of Legal Entity</span>
      </div>
      <div class="col-12 margin-t-s">
        <upload-image
          @change="getFile($event)"
          @deleteFile="cropped = ''"
          @editImage="(val) => cropped = val.data.location"
          :logo="cropped"
          :includeLeId="true"
        />
      </div>
    </div>
    <div class="margin-t-m"  :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="row">
        <txt
          label="Legal Entity Name *"
          type="text"
          name="legal_name"
          data-vv-as="legal name"
          v-model="leData.legalName"
          v-validate="{required: true, max: nameMaxlength}"
          :classname="errors.has('legal_name')"
          :errormsg="errors.first('legal_name')"
        ></txt>
        <txt
          :class="client_code_exist ? 'point-events-none' : ''"
          label="Client Code *"
          name="clientCode"
          data-vv-as="client code"
          type="text"
          v-model="leData.clientCode"
          v-validate="'required'"
          :disable="client_code_exist"
          :classname="errors.has('clientCode')"
          :errormsg="errors.first('clientCode')"
        ></txt>
      </div>
      <div class="row margin-t-m">
        <tl-select
          name="industryRegType"
          class="customwidth"
          labelText="name"
          label="Industry Registration *"
          :options="industryTypesArray"
          v-model="industryRegTypeID"
          @change="(val)=>industryRegTypeID=val"
          data-vv-as="Industry Registration"
          v-validate="{required:true}"
          :classname="errors.has('industryRegType')"
          :errormsg="errors.first('industryRegType')"
        ></tl-select>
        <div class="label">
          <!-- PL_2905 -->
          <span class="input-label">Incorporation Date *</span>
          <date-picker
            @datevalue="(val)=>{leData.incorporationDate=val;incorporationDateChanged(val)}"
            class="customwidth"
            v-model="leData.incorporationDate"
            name="incorporationDate"
            :dates-disabled="{from: new Date(new Date().setDate(new Date().getDate()))}"
            data-vv-as="Incorporation date"
            v-validate="{required:true}"
            :classname="errors.has('incorporationDate')"
            :errormsg="errors.first('incorporationDate')"
          />
          <!-- PL_2905 -->
        </div>
      </div>
      <div class="row margin-t-m">
        <tl-select
          class="customwidth"
          label="Industry Type *"
          name="industryType"
          labelText="name"
          :options="industrytype"
          v-model="industryTypeID"
          @change="(val)=>industryTypeID=val"
          data-vv-as="Industry type"
          v-validate="{required:true}"
          :classname="errors.has('industryType')"
          :errormsg="errors.first('industryType')"
        ></tl-select>
        <div class="label">
          <!-- PL_2905 -->
          <span class="input-label">Legal Entity Activation Date *</span>
          <date-picker
            class="customwidth"
            @datevalue="(val)=>leData.legalActivationDate=val"
            v-model="leData.legalActivationDate"
            name="LEactivationDate"
            :disable="!(leData.incorporationDate)"
            :dates-disabled="{to: new Date(leData.incorporationDate),from: new Date(new Date().setDate(new Date().getDate()))}"
            data-vv-as="Activation date"
            v-validate="{required:true}"
            :classname="errors.has('LEactivationDate')"
            :errormsg="errors.first('LEactivationDate')"
          />
          <!-- PL_2905 -->
        </div>
      </div>
    </div>
    <div class="margin-t-s"  :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2">
        <span class="text">Registered Address</span>
      </div>
      <div class="row margin-t-s">
        <txt
          label="Address Line 1"
          name="addresRegLineOne"
          id="addresRegLineOne"
          type="text"
          v-model="leData.registeredAddress.addressLineOne"
          @change="(val)=>{leData.registeredAddress.addressLineOne=val.trim()}"
          data-vv-as="address line 1"
          v-validate="{required: false}"
          :classname="errors.has('addresRegLineOne')"
          :errormsg="errors.first('addresRegLineOne')"
        ></txt>

        <txt
          label="Address Line 2"
          name="addressLineTwo"
          type="text"
          v-model="leData.registeredAddress.addressLineTwo"
          @change="(val)=>{leData.registeredAddress.addressLineTwo=val.trim()}"
          data-vv-as="address line 2"
          v-validate="{required: false}"
          :classname="errors.has('addressLineTwo')"
          :errormsg="errors.first('addressLineTwo')"
        ></txt>
      </div>
      <div class="row margin-t-m">
        <tl-select
          class="customwidth"
          label="Country *"
          name="country"
          labelText="name"
          :options="countriesListArray"
          :disable="true"
          v-model="countryID"
          @change="(val)=>{countryID = val;leData.registeredAddress.countryID=val.id}"
        ></tl-select>

        <tl-select
          class="customwidth"
          :label="`State / Union Territory ${(leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ? '*' : ''}`"
          name="regAddState"
          labelText="state_name"
          :options="state"
          v-model="stateID"
          @change="(val)=>{stateID=val; leData.registeredAddress.cityID = null;cityID=null; leData.isSameAsHeadAddress ? (headOfficeStateID = val, headOfficeCityID = null):'' ;leData.isSameAsGstAddress ? (gstStateID = val, gstCityID = null):''; leData.isSameAsDispatchAddress ? (dispatchStateID = val, dispatchCityID = null):''}"
          v-validate="{required: (leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ? true : false}"
          data-vv-as="State / Union Territory"
          :classname="errors.has('regAddState')"
          :errormsg="errors.first('regAddState')"
        ></tl-select>
        <!-- PL_2342 -->
      </div>
      <div class="row margin-t-m">
        <tl-select
          class="customwidth"
          :label="`City ${(leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ? '*' : ''}`"
          name="regAddCity"
          labelText="city_name"
          :options="stateID ? stateID.City: []"
          v-model="cityID"
          @change="(val)=>{cityID=val;leData.isSameAsHeadAddress ? headOfficeCityID=val:''; leData.isSameAsGstAddress ? gstCityID = val:''; leData.isSameAsDispatchAddress ? dispatchCityID=val:''}"
          data-vv-as="City"
          v-validate="{required: (((stateID && stateID.City.length) && (leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ) ? true : false)}"
          :classname="errors.has('regAddCity')"
          :errormsg="errors.first('regAddCity')"
        ></tl-select>
        <txt
          :label="`Pincode ${(leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ? '*' : ''}`"
          type="text"
          name="pincode"
          maxlength="6"
          v-numeric-only
          v-model="leData.registeredAddress.pincode"
          v-validate="{required: (leData.registeredAddress.addressLineOne || leData.registeredAddress.addressLineTwo) ? true: false, length:6, regex:pincodeRegex}"
          :classname="errors.has('pincode')"
          :errormsg="errors.first('pincode')"
        ></txt>
      </div>
      <div class="row margin-t-m">
        <div>
          <txt
            label="Email Id"
            type="text"
            name="registeredAddressEmail"
            data-vv-as="email"
            v-model="leData.registeredAddress.email"
            v-validate="{max:100, regex:emailRegex}"
            :errormsg="errors.first('registeredAddressEmail')"
          ></txt>
          <span class="errorMessage" v-show="errors.has('registeredAddressEmail')">
            <span class="error">Please enter a valid email</span>
          </span>
        </div>
        <div>
          <txt
            label="Phone Number *"
            type="text"
            name="registeredAddressPhoneNumber"
            data-vv-as="phone number"
            v-model="leData.registeredAddress.phoneNumber"
            v-validate="{required: true,regex: phoneNumRegex, min:10, max:10}"
            :classname="errors.has('registeredAddressPhoneNumber')"
            :errormsg="errors.first('registeredAddressPhoneNumber')"
          ></txt>
        </div>
      </div>
    </div>
    <div class="margin-t-s" :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2">
        <span class="text">Head Office</span>
      </div>
      <div class="row">
        <div class="col-12 margin-t-s padding-l-n">
          <tl-checkbox
            class="samecheck"
            label="Same as Registered Address"
            v-model="leData.isSameAsHeadAddress"
            @change="mapAddress('headoffice')"
          />
        </div>
        <div class="row margin-t-m">
          <txt
            label="Address Line 1"
            type="text"
            name="headOfficeAddressLineOne"
            id="headOfficeAddressLineOne"
            data-vv-as="address line 1"
            v-model="leData.headOfficeAddress.addressLineOne"
            @change="(val)=>{leData.headOfficeAddress.addressLineOne=val.trim()}"
            v-validate="{required: false}"
            :disable=headOfficeAddressDisable
            :classname="errors.has('headOfficeAddressLineOne')"
            :errormsg="errors.first('headOfficeAddressLineOne')"
          ></txt>
          <txt
            label="Address Line 2"
            type="text"
            name="headOfficeAddressLineTwo"
            v-model="leData.headOfficeAddress.addressLineTwo"
            @change="(val)=>{leData.headOfficeAddress.addressLineTwo=val.trim()}"
            data-vv-as="address line 2"
            v-validate="{required: false}"
            :disable=headOfficeAddressDisable
            :classname="errors.has('headOfficeAddressLineTwo')"
            :errormsg="errors.first('headOfficeAddressLineTwo')"
          ></txt>
        </div>
        <div class="row margin-t-m">
          <tl-select
            class="customwidth"
            label="Country"
            labelText="name"
            name="headOfficeCountry"
            :options="countriesListArray"
            :disable="true"
            v-model="headOfficeCountryID"
            @change="(val)=>{headOfficeCountryID = val; leData.headOfficeAddress.countryID=val.id}"
          ></tl-select>
          <tl-select
            class="customwidth"
            :label="`State / Union Territory ${(leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo) ? '*' : ''}`"
            labelText="state_name"
            name="headOfficeState"
            :options="state"
            v-model="headOfficeStateID"
            @change="(val)=>{headOfficeStateID=val; leData.headOfficeAddress.cityID = null;headOfficeCityID=null;leData.isSameAsHeadAddress ? (stateID = val, cityID=null):'' ;leData.isSameAsGstAddress ? (gstStateID = val, gstCityID = null):''; leData.isSameAsDispatchAddress ? (dispatchStateID = val, dispatchCityID = null):''}"
            v-validate="{required: (leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo) ? true: false}"
            data-vv-as="State / Union Territory"
            :disable=headOfficeAddressDisable
            :classname="errors.has('headOfficeState')"
            :errormsg="errors.first('headOfficeState')"
          />
          <!-- PL_2342 -->
        </div>
        <div class="row margin-t-m">
          <tl-select
            class="customwidth"
            :label="`City ${(leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo) ? '*' : ''}`"
            name="headOfficeCity"
            labelText="city_name"
            :options="headOfficeStateID? headOfficeStateID.City:[]"
            v-model="headOfficeCityID"
            @change="(val)=>{headOfficeCityID = val;leData.isSameAsHeadAddress ? cityID=val:''; leData.isSameAsGstAddress ? gstCityID = val:''; leData.isSameAsDispatchAddress ? dispatchCityID=val:''}"
            :disabled="headOfficeStateID && headOfficeStateID.City.length ?false:true"
            :disable=headOfficeAddressDisable
            v-validate="{required: ((headOfficeStateID && headOfficeStateID.City.length) && (leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo)) ? true : false}"
            data-vv-as="City"

            :classname="errors.has('headOfficeCity')"
            :errormsg="errors.first('headOfficeCity')"
          ></tl-select>
          <txt
            :label="`Pincode ${(leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo) ? '*' : ''}`"
            type="text"
            name="headOfficePincode"
            data-vv-as="pincode"
            maxlength="6"
            v-numeric-only
            v-model="leData.headOfficeAddress.pincode"
            v-validate="{required: (leData.headOfficeAddress.addressLineOne || leData.headOfficeAddress.addressLineTwo) ? true: false, length:6, regex:pincodeRegex}"
            :disable=headOfficeAddressDisable
            :classname="errors.has('headOfficePincode')"
            :errormsg="errors.first('headOfficePincode')"
          ></txt>
        </div>
        <div class="row margin-t-m">
          <div>
            <txt
              label="Email Id"
              type="text"
              name="headOfficeEmail"
              data-vv-as="email"
              v-model="leData.headOfficeAddress.email"
              v-validate="{required: false, regex:emailRegex}"
              :errormsg="errors.first('headOfficeEmail')"
            ></txt>
            <span class="errorMessage" v-show="errors.has('headOfficeEmail')">
              <span class="error">Please enter a valid email</span>
            </span>
          </div>
          <div>
            <txt
              label="Phone Number *"
              type="text"
              name="headOfficePhoneNumber"
              data-vv-as="phone number"
              v-model="leData.headOfficeAddress.phoneNumber"
              v-validate="{required: true,regex: phoneNumRegex, min:10}"
              :disable=headOfficeAddressDisable
              :classname="errors.has('headOfficePhoneNumber')"
              :errormsg="errors.first('headOfficePhoneNumber')"
            ></txt>
            <!-- :maxlength="headOffPhoneNumberMaxlength"
              @change="(val)=>{ if(val.split('')[0] == '0'){headOffPhoneNumberMaxlength = '11'}else{
              headOffPhoneNumberMaxlength='10'
            }}"-->
          </div>
        </div>
      </div>
    </div>
    <div class="margin-t-s" :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2">
        <span class="text">Company Identification Details</span>
      </div>
      <div class="row margin-t-s">
        <txt
          label="CIN Number *"
          type="text"
          name="cinNumber"
          data-vv-as="CIN number"
          v-validate="{required: true, regex: corporateIdentityRegex, length:21}"
          v-model="leData.CINNumber"
          :classname="errors.has('cinNumber')"
          :errormsg="errors.first('cinNumber')"
        ></txt>

        <txt
          label="PAN Number *"
          name="panNumber"
          data-vv-as="PAN number"
          type="text"
          v-validate="{required: true, regex: pancardRegex, length:10}"
          v-model="leData.PANNumber"
          @change="(val)=> leData.PANNumber = val.toUpperCase()"
          :classname="errors.has('panNumber')"
          :errormsg="errors.first('panNumber')"
          v-uppercase
        ></txt>

        <div class="row margin-t-m">
          <txt
            label="TAN Number *"
            type="text"
            name="tanNumber"
            data-vv-as="TAN number"
            v-model="leData.TANNumber"
            v-validate="{required: true,regex: taxAccountNumRegex, length:10}"
            :classname="errors.has('tanNumber')"
            :errormsg="errors.first('tanNumber')"
          ></txt>

          <txt
            label="TAN Circle *"
            type="text"
            name="tanCircle"
            data-vv-as="TAN circle"
            v-model="leData.TANCircle"
            v-validate="{required:true, max:50}"
            :classname="errors.has('tanCircle')"
            :errormsg="errors.first('tanCircle')"
          ></txt>
        </div>
      </div>
    </div>
    <div class="margin-t-s" :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2">
        <span class="text">Invoicing Details</span>
      </div>
      <div class="row">
        <div class="col-12 margin-t-s padding-l-n">
          <tl-checkbox
            class="samecheck"
            label="Same as Registered Address"
            v-model="leData.isSameAsGstAddress"
            @change="mapAddress('gst')"
          />
        </div>
        <div class="row margin-t-m">
          <txt
            label="GST Number *"
            name="gstNumber"
            data-vv-as="GST Number"
            type="text"
            v-model="leData.GSTNumber"
            v-validate="{required: true, regex: goodsServiceTaxRegex, length: 15}"
            :classname="errors.has('gstNumber')"
            :errormsg="errors.first('gstNumber')"
          ></txt>

          <txt
            label="Address Line 1"
            type="text"
            name="invoiceAddressLineOne"
            v-model="leData.gstAddress.addressLineOne"
            @change="(val)=>{leData.gstAddress.addressLineOne=val.trim()}"
            data-vv-as="address line 1"
            v-validate="{required: false}"
            :disable=gstAddressDisable
            :classname="errors.has('invoiceAddressLineOne')"
            :errormsg="errors.first('invoiceAddressLineOne')"
          ></txt>
        </div>
        <div class="row margin-t-m">
          <txt
            label="Address Line 2"
            type="text"
            name="invoiceAddressLineTwo"
            v-model="leData.gstAddress.addressLineTwo"
            @change="(val)=>{leData.gstAddress.addressLineTwo=val.trim()}"
            data-vv-as="address line 2"
            v-validate="{required: false}"
            :disable=gstAddressDisable
            :classname="errors.has('invoiceAddressLineTwo')"
            :errormsg="errors.first('invoiceAddressLineTwo')"
          ></txt>
          <tl-select
            class="customwidth"
            label="Country"
            name="invoiceCountry"
            labelText="name"
            :options="countriesListArray"
            :disable="true"
            v-model="gstCountryID"
            @change="(val)=>{gstCountryID=val;leData.gstAddress.countryID=val.id}"
          ></tl-select>
        </div>

        <div class="row margin-t-m">
          <tl-select
            class="customwidth"
            :label="`State / Union Territory ${(leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo) ? '*' : ''}`"
            labelText="state_name"
            name="invoiceState"
            :options="state"
            v-model="gstStateID"
            @change="(val)=> {gstStateID =val; leData.gstAddress.cityID = null;gstCityID=null; leData.isSameAsHeadAddress ? (headOfficeStateID = val, headOfficeCityID = null):'' ;leData.isSameAsGstAddress ? (stateID = val, cityID=null):''; leData.isSameAsDispatchAddress ? (dispatchStateID = val, dispatchCityID = null):''}"
            data-vv-as="State / Union Territory"
            v-validate="{required: (leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo) ? true: false}"
            :disable=gstAddressDisable
            :classname="errors.has('invoiceState')"
            :errormsg="errors.first('invoiceState')"
          ></tl-select>
          <!-- PL_2342 -->
          <tl-select
            class="customwidth"
            :label="`City ${(leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo) ? '*' : ''}`"
            name="invoiceCity"
            labelText="city_name"
            :options="gstStateID ? gstStateID.City:[]"
            v-model="gstCityID"
            @change="(val)=>{gstCityID = val; leData.isSameAsHeadAddress ? headOfficeCityID=val:''; leData.isSameAsGstAddress ? cityID = val:''; leData.isSameAsDispatchAddress ? dispatchCityID=val:''}"
            data-vv-as="City"
            :disabled="gstStateID && gstStateID.City.length?false:true"
            :disable=gstAddressDisable
            v-validate="{required: ((gstStateID &&  gstStateID.City.length) && (leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo)) ? true : false}"
            :classname="errors.has('invoiceCity')"
            :errormsg="errors.first('invoiceCity')"
          ></tl-select>
        </div>
        <div class="row margin-t-m">
          <div>
            <txt
              :label="`Pincode ${(leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo) ? '*' : ''}`"
              type="text"
              name="invoicePincode"
              data-vv-as="pincode"
              maxlength="6"
              v-numeric-only
              v-model="leData.gstAddress.pincode"
              v-validate="{required: (leData.gstAddress.addressLineOne || leData.gstAddress.addressLineTwo) ? true: false, length:6, regex:pincodeRegex}"
              :disable=gstAddressDisable
              :classname="errors.has('invoicePincode')"
              :errormsg="errors.first('invoicePincode')"
            ></txt>
          </div>
          <div>
            <txt
              label="Email Id"
              type="text"
              name="invoiceEmail"
              data-vv-as="email"
              v-model="leData.gstAddress.email"
              v-validate="{required: false, regex:emailRegex}"
              :errormsg="errors.first('invoiceEmail')"
            ></txt>
            <span class="errorMessage" v-show="errors.has('invoiceEmail')">
              <span class="error">Please enter a valid email</span>
            </span>
          </div>
        </div>
        <div class="row margin-t-m">
          <txt
            label="Phone Number *"
            type="text"
            name="invoicePhoneNumber"
            data-vv-as="phone number"
            v-model="leData.gstAddress.phoneNumber"
            v-validate="{required: true,regex: phoneNumRegex, min:10}"
            :disable=gstAddressDisable
            :classname="errors.has('invoicePhoneNumber')"
            :errormsg="errors.first('invoicePhoneNumber')"
          ></txt>
        </div>
      </div>
    </div>
    <div class="margin-t-s" :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2">
        <span class="text">Dispatch Address</span>
      </div>
      <div class="row">
        <div class="col-12 margin-t-s padding-l-n">
          <tl-checkbox
            class="samecheck"
            label="Same as Registered Address"
            v-model="leData.isSameAsDispatchAddress"
            @change="mapAddress('dispatch')"
          />
        </div>
        <div class="row margin-t-m">
          <txt
            label="Address Line 1"
            type="text"
            name="dispatchAddressLineOne"
            v-model="leData.dispatchAddress.addressLineOne"
            @change="(val)=>{leData.dispatchAddress.addressLineOne=val.trim()}"
            data-vv-as="address line 1"
            v-validate="{required: false}"
            :disable=dispatchAddressDisable
            :classname="errors.has('dispatchAddressLineOne')"
            :errormsg="errors.first('dispatchAddressLineOne')"
          ></txt>

          <txt
            label="Address Line 2"
            type="text"
            name="dispatchAddressLineTwo"
            v-model="leData.dispatchAddress.addressLineTwo"
            @change="(val)=>{leData.dispatchAddress.addressLineTwo=val.trim()}"
            data-vv-as="address line 2"
            v-validate="{required: false}"
            :disable=dispatchAddressDisable
            :classname="errors.has('dispatchAddressLineTwo')"
            :errormsg="errors.first('dispatchAddressLineTwo')"
          ></txt>
        </div>
        <div class="row margin-t-m">
          <tl-select
            class="customwidth"
            label="Country"
            name="dispatchCountry"
            labelText="name"
            :options="countriesListArray"
            :disable="true"
            v-model="dispatchCountryID"
            @change="(val)=>{dispatchCountryID = val;leData.dispatchAddress.countryID=val.id}"
          ></tl-select>

          <tl-select
            class="customwidth"
            :label="`State / Union Territory ${(leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo) ? '*' : ''}`"
            labelText="state_name"
            name="dispatchState"
            :options="state"
            v-model="dispatchStateID"
            @change="(val)=>{dispatchStateID=val;leData.dispatchAddress.cityID = null;dispatchCityID=null; leData.isSameAsGstAddress ? (gstStateID = val, gstCityID = null): '';leData.isSameAsDispatchAddress ? (stateID = val, cityID=null):'';leData.isSameAsHeadAddress ? (headOfficeStateID = val, headOfficeCityID = null):''}"
            data-vv-as="state"
            v-validate="{required: (leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo) ? true: false}"
            :disable=dispatchAddressDisable
            :classname="errors.has('dispatchState')"
            :errormsg="errors.first('dispatchState')"
          ></tl-select>
          <!-- PL_2342 -->
        </div>
        <div class="row margin-t-m">
          <tl-select
            class="customwidth"
            :label="`City ${(leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo) ? '*' : ''}`"
            name="dispatchCity"
            labelText="city_name"
            :options="dispatchStateID ? dispatchStateID.City:[]"
            v-model="dispatchCityID"
            @change="(val)=>{dispatchCityID=val;leData.isSameAsHeadAddress ? headOfficeCityID=val:''; leData.isSameAsGstAddress ? gstCityID = val:''; leData.isSameAsDispatchAddress ? cityID=val:''}"
            data-vv-as="city"
            :disabled="dispatchStateID && dispatchStateID.City.length?false:true"
            :disable= dispatchAddressDisable
            v-validate="{required: ((dispatchStateID && dispatchStateID.City.length) && (leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo)) ? true : false}"
            :classname="errors.has('dispatchCity')"
            :errormsg="errors.first('dispatchCity')"
          ></tl-select>
          <txt
            :label="`Pincode ${(leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo) ? '*' : ''}`"
            type="text"
            name="dispatchPincode"
            data-vv-as="pincode"
            maxlength="6"
            v-numeric-only
            v-model="leData.dispatchAddress.pincode"
            v-validate="{required: (leData.dispatchAddress.addressLineOne || leData.dispatchAddress.addressLineTwo) ? true: false, length:6, regex:pincodeRegex}"
            :disable=dispatchAddressDisable
            :classname="errors.has('dispatchPincode')"
            :errormsg="errors.first('dispatchPincode')"
          ></txt>
        </div>
        <div class="row margin-t-m">
          <div>
            <txt
              label="Email Id"
              type="text"
              name="dispatchEmail"
              data-vv-as="email"
              v-model="leData.dispatchAddress.email"
              v-validate="{required: false, regex:emailRegex}"
              :errormsg="errors.first('dispatchEmail')"
            ></txt>
            <span class="errorMessage" v-show="errors.has('dispatchEmail')">
              <span class="error">Please enter a valid email</span>
            </span>
          </div>
          <div>
            <txt
              label="Phone Number *"
              type="text"
              name="dispatchPhoneNumber"
              data-vv-as="phone number"
              v-model="leData.dispatchAddress.phoneNumber"
              v-validate="{required: true, regex: phoneNumRegex, min:10}"
              :disable=dispatchAddressDisable
              :classname="errors.has('dispatchPhoneNumber')"
              :errormsg="errors.first('dispatchPhoneNumber')"
            ></txt>
            <!--
              :maxlength="dispatchAddPhoneNumberMaxlength"
              @change="(val)=>{ if(val.split('')[0] == '0'){dispatchAddPhoneNumberMaxlength = '11'}else{
              dispatchAddPhoneNumberMaxlength='10'
              }}"
            -->
          </div>
        </div>
      </div>
    </div>
    <div class="margin-t-s" :disabled="!(ifTeamleaderPermission || ifSuperAdmin)">
      <div class="header header2" v-if="leData.contactDetails">
        <span class="text">Contact Point (Escalation Matrix)</span>
      </div>
      <div v-if="leData.contactDetails">
        <div class="row" v-for="(count,index) in leData.contactDetails" :key="index">
          <div class="col-12 margin-t-s padding-l-n">
            <span class="label">Level {{index+1}}</span>
          </div>
          <div class="row margin-t-m">
            <txt
              label="Full Name *"
              type="text"
              :name="'name'+index"
              data-vv-as="name"
              v-model="count.name"
              v-validate="{required: true}"
              :classname="errors.has('name'+index)"
              :errormsg="errors.first('name'+index)"
            ></txt>
            <txt
              label="Phone Number *"
              type="text"
              :name="'contactPointPhoneNumber'+index"
              data-vv-as="phone number"
              v-model="count.phoneNumber"
              v-validate="{required: true,regex: phoneNumRegex, min:10}"
              :classname="errors.has('contactPointPhoneNumber'+index)"
              :errormsg="errors.first('contactPointPhoneNumber'+index)"
            ></txt>
          </div>
          <div class="row margin-t-m">
            <div>
              <txt
                label="Email Id"
                type="text"
                :name="'contactPointEmail'+index"
                data-vv-as="email"
                v-model="count.email"
                v-validate="{regex:emailRegex}"
                :errormsg="errors.first('contactPointEmail'+index)"
              ></txt>
              <span class="errorMessage" v-show="errors.has('contactPointEmail'+index)">
                <span class="error">Please enter a valid email</span>
              </span>
            </div>
            <div>
              <txt label="Remarks" type="text" :name="'remarks'+index" v-model="count.remarks"></txt>
            </div>
          </div>
          <div class="col-6" v-if="index"></div>
          <div class="col-6 margin-t-s" v-if="index">
            <a
              href="javascript:void(0)"
              class="delete-level"
              v-on:click="deleteLevel(index)"
            >Delete Level</a>
          </div>
        </div>
        <div class="row margin-t-m">
          <div class="col-12 padding-l-n">
            <btn type="secondary" text="Add Level" @click="addlevel" />
          </div>
        </div>
      </div>
    </div>
    <div class="header header2">
      <span class="text">Login Based On *</span>
    </div>
    <div :disabled="disableLogin">
      <div class="col-3 padding-l-n margin-t-m">
        <tl-radio
          label="User Name"
          name="loginBasedOnUserName"
          id="user_name"
          value="user_name"
          v-model="leData.loginBasedOnUserName"
        />
      </div>
      <div class="col-3 padding-l-n margin-t-m">
        <tl-radio
          label="Email"
          name="loginBasedOnEmail"
          id="email"
          value="email"
          v-model="leData.loginBasedOnEmail"
        />
      </div>
    </div>
    <div class="header header2">
      <span class="text">Services Availed *</span>
    </div>
    <div :disabled="disableService">
      <div class="col-3 padding-l-n margin-t-m">
        <tl-radio
          label="Payroll"
          name="serviceAvailed"
          id="payroll"
          value="payroll"
          v-model="leData.serviceAvailed"
        />
      </div>
      <div class="col-3 padding-l-n margin-t-m">
        <tl-radio
          label="HCM"
          name="serviceAvailed"
          id="hcm"
          value="hcm"
          v-model="leData.serviceAvailed"
        />
      </div>
    </div>
    <div>
      <div class="header header2">
        <span class="text">Compensation</span>
      </div>
      <div class="col-3 padding-l-n margin-t-m">
        <tl-checkbox
          label="Enable compensation for ESS"
          name="leData.enable_ctc_report"
          v-model="leData.enable_ctc_report"
        />
      </div>
    </div>
    <div>
      <div class="header header2">
        <span class="text">Clear Tax Integration</span>
      </div>
      <div class="col-3 padding-l-n margin-t-m">
        <tl-checkbox
          label="Enable IT Returns with Clear Tax"
          name="leData.enable_clear_tax"
          v-model="leData.enable_clear_tax"
        />
      </div>
    </div>
    <div class="header header2">
        <span class="text">IT declartion</span>
      </div>
    <div class="col-3 padding-l-n margin-t-m">
        <tl-checkbox
          label="Enable IT for Political Party"
          name="leData.enable_political_party_component"
          v-model="leData.enable_political_party_component"
        />
      </div>
     <div class="header header2">
        <span class="text">Arrear</span>
      </div>
    <div class="col-6 padding-l-n margin-t-m">
        <tl-checkbox
          label="Separate Working & RLOP Arrears days"
          name="leData.is_arrears_separate"
          v-model="leData.is_arrears_separate"
        />
      </div>
    <div class="header header2">
      <span class="text">FBP</span>
    </div>
    <div class="row center" :disabled="!(ifSuperAdmin)">
      <div class="col-3 padding-l-n margin-t-m">
        <tl-checkbox
          label="Enable FBP"
          name="leData.enable_fbp"
          v-model="leData.enable_fbp"
        />
      </div>
      <div class="col-3 padding-l-n margin-t-m" v-show="leData.enable_fbp">
        <tl-select
          class="customwidthFbp"
          label="FBP Based On"
          name="based_on"
          labelText="based_on"
          :options="['CTC', 'Category']"
          v-model="leData.based_on"
          @change="(val)=>leData.based_on = val"
        ></tl-select>
      </div>
      <div class="col-3 padding-l-n margin-t-m" v-show="leData.enable_fbp">
        <tl-select
          class="customwidthFbp"
          label="FBP Arrears Calculation from"
          name="fbp_calculated_on"
          labelText="fbp_calculated_on"
          :options="['Effective', 'Current']"
          v-model="leData.fbp_calculated_on"
          @change="(val)=>leData.fbp_calculated_on = val"
        ></tl-select>
      </div>
    </div>
    <div class="input-label margintop-24" v-show="leData.enable_fbp">FBP Lock Between</div>
    <div class="row margin-t-m center" v-show="leData.enable_fbp" :disabled="!(ifSuperAdmin)">
      <tl-select
        :options="startDateOptions"
        class="customwidth"
        v-model="leData.fbp_lock_btw_from"
        placeholder="From"
        @change="changeDate($event)"
        data-vv-as="from"
        v-validate="{required: true}"
      ></tl-select>
      <tl-select
        class="customwidth"
        placeholder="To"
        v-show="leData.enable_fbp"
        :options="startDateOptions"
        v-model="leData.fbp_lock_btw_to"
        @change="(val)=>leData.fbp_lock_btw_to = val"
        data-vv-as="to"
        v-validate="{required: true}"
      ></tl-select>
      <tl-checkbox
        label="FBP processed with salary"
        v-show="leData.enable_fbp"
        name="leData.fbp_processed_with_salary"
        v-model="leData.fbp_processed_with_salary"
        />
    </div>
    <!-- <div class="" :disabled="!(ifSuperAdmin)">
      
    </div> -->
    <div class="col-3 padding-l-n margin-t-m"  v-show="leData.enable_fbp" :disabled="!(ifSuperAdmin)">
        <span class="text">FBP Settlement Type</span>
        <div class="center" style="margin-top: 10px;">
          <tl-radio
            label="Yearly"
            name="fbp_settlement_type"
            id="Yearly"
            value="Yearly"
            v-model="leData.fbp_settlement_type"
          />
          <tl-radio
            label="Monthly"
            name="fbp_settlement_type"
            id="Monthly"
            value="Monthly"
            v-model="leData.fbp_settlement_type"
          />
        </div>
      </div>

    <!-- <div class="margin-t-s">
      <div class="header header2">
        <span class="text">Employee Code Format</span>
      </div>
      <div class="row">
        <div class="col-12 padding-l-n margin-t-m">
          <tl-checkbox
            label="Generate automatically"
            name="leData.autogenerate_employee_code"
            ref="empCode"
            v-model="leData.autogenerate_employee_code"
          />
          <div class="margin-t-m" v-show="leData.autogenerate_employee_code">
            <div class="row">
              <div class="col-12 padding-l-n">
                <txt
                  label="Length*"
                  name="length"
                  type="text"
                  v-numeric-only
                  v-model="leData.length"
                  v-validate="'required_if:empCode,true'"
                  :classname="errors.has('length')"
                  errormsg="The length field is required"
                />
              </div>
              <div class="col-12 margin-t-m padding-l-n">
                <txt
                  label="Prefix*"
                  type="text"
                  name="prefix"
                  v-model="leData.prefix"
                  v-validate="'required_if:empCode,true'"
                  :classname="errors.has('prefix')"
                  errormsg="The prefix field is required"
                />
              </div>
              <div class="col-12 margin-t-m padding-l-n">
                <txt
                  label="Starting Number*"
                  type="text"
                  v-numeric-only
                  name="startingNumber"
                  data-vv-as="starting number"
                  v-model="leData.number"
                  v-validate="'required_if:empCode,true|numeric:true'"
                  :classname="errors.has('startingNumber')"
                  errormsg="The starting number field is required"
                />
              </div>
              <div class="col-12 margin-t-m padding-l-n">
                <txt label="Suffix" type="text" name="suffix" v-model="leData.suffix" />
                <!-v-validate="'required_if:empCode,true'"
                  :classname="errors.has('suffix')"
                errormsg="The suffix field is required"-->
<!--              </div>
              <div class="col-12 margin-t-s padding-l-n">
                <a href="javascript:void(0)" @click="updateEmployeeCode">show preview</a>
              </div>
            </div>

            <div class="col-6 margintop-32" v-if="showPreview">
              <span>
                <b>Employee Code Preview</b>
              </span>
              <div class="code-preview margin-t-m">
                <span>{{finalCode}}</span>
              </div>
              <div
                class="danger"
                v-if="((leData.prefix+leData.number+leData.suffix).length > Number(leData.length))"
              >The total of Prefix, Starting Number and Suffix should be less than or equal to {{leData.length}}.</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goToOrgSummary" />
          <btn :text="`${editMode ? 'Update' : 'Save'}`" type="primary" @click="submitLegalEntity" v-show="ifTeamleaderPermission || ifSuperAdmin"/>
          <btn text="Next" type="primary" @click="nextPage" v-show="!(ifTeamleaderPermission || ifSuperAdmin)"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { selectMixin } from "@/mixins/selectMixin";
import * as config from "@/apis/config.js";

export default {
  mixins: [selectMixin],
  data() {
    return {

      nameMaxlength: null,
      regAddPhoneNumberMaxlength: "10",
      headOffPhoneNumberMaxlength: "10",
      invoicePhoneNumberMaxlength: "10",
      dispatchAddPhoneNumberMaxlength: "10",
      contactPointPhoneNumberMaxlength: "10",
      phoneNumRegex: null,
      emailRegex: null,
      pincodeRegex: null,
      pancardRegex: null,
      corporateIdentityRegex: null,
      taxAccountNumRegex: null,
      goodsServiceTaxRegex: null,
      cropped: null,
      newlyCreatedLegalEntityID: null,
      legalEntityList: [],
      editMode: false,
      showPreview: false,
      finalCode: "",
      industrytype: [],
      city: [],
      state: [],
      countriesListArray: [],
      industryTypesArray: [],
      selected: "",
      showpopup: false,
      toast: false,
      popupTitle: "",
      message: "Legal Entity Saved Succesfully.",
      errmsg: "",
      countryID: null,
      stateID: null,
      cityID: null,
      headOfficeCountryID: null,
      headOfficeStateID: null,
      headOfficeCityID: null,
      gstCountryID: null,
      gstStateID: null,
      gstCityID: null,
      dispatchCountryID: null,
      dispatchStateID: null,
      dispatchCityID: null,
      industryTypeID: null,
      industryRegTypeID: null,
      leData: {
        org_id: "",
        employee_code_format: {},
        legalName: "",
        industryTypeID: null,
        industryRegTypeID: null,
        logoURL: "",
        isSameAsHeadAddress: false,
        autogenerate_employee_code: false,
        isSameAsDispatchAddress: false,
        isSameAsGstAddress: false,
        registeredAddress: {
          addressLineOne: "",
          addressLineTwo: "",
          pincode: null,
          email: null,
          phoneNumber: "",
          countryID: null,
          cityID: null,
          stateID: null
        },
        headOfficeAddress: {
          addressLineOne: "",
          headOfficeAddressDisable:false,
          addressLineTwo: "",
          pincode: null,
          email: null,
          phoneNumber: "",
          countryID: null,
          cityID: null,
          stateID: null
        },
        gstAddress: {
          addressLineOne: "",
          gstAddressDisable:false,
          addressLineTwo: "",
          pincode: null,
          email: null,
          phoneNumber: "",
          countryID: null,
          cityID: null,
          stateID: null
        },
        dispatchAddress: {
          addressLineOne: "",
          dispatchAddressDisable:false,
          addressLineTwo: "",
          pincode: null,
          email: null,
          phoneNumber: "",
          countryID: null,
          cityID: null,
          stateID: null
        },
        clientCode: "",
        incorporationDate: "",
        legalActivationDate: "",
        contactDetails: [{ name: "", phoneNumber: "", email: "", remarks: "" }],
        TANNumber: "",
        CINNumber: "",
        PANNumber: "",
        TANCircle: "",
        GSTNumber: "",
        status: "",
        prefix: "",
        suffix: "",
        password_policy: null,
        length: "", // PL_2895
        number: "", // PL_2895
        enable_fbp: false,
        enable_ctc_report: false,
        based_on: "CTC",
        fbp_calculated_on:"",
        fbp_lock_btw_from: 1,
        fbp_lock_btw_to: 31,
        fbp_processed_with_salary: true,
        loginBasedOnUserName: '',
        loginBasedOnEmail: '',
        disableLogin: false,
        serviceAvailed: '',
        fbp_settlement_type: 'Yearly',
        disableService: false,
        enable_clear_tax:false,
        enable_political_party_component:false,
        is_arrears_separate: false,
      },
      legalEntityInfoValue: false,
      role: "",
      startDateOptions: [],
      client_code_exist: false,
    };
  },

  computed: {
    ...mapState({
      legalEntityData: state => state.onboard.legal_entities.data,
      globalData: state => state.globalapi.globalData.data
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ...mapGetters("onboard/legal_entities", {
      legalEntity: "record",
      editForm: "editMode"
    }),
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.legalEntityInfoValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }
      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.legalEntityInfoValue) {
      //   return true;
      //   } 
      //   else {
      //     return true;
      //   }
      // }
      //else {
      // return false
      //}
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  beforeCreate() {
    try {
      this.countriesListArray = config.GlobalList.countriesList;
    } catch (err) {
      this.errmsg = err;
      this.toast = true;
    }
  },

  activated() {
    // PL_2895
    this.getAllDates();
    this.setGlobalData();
    this.$validator.reset();
    this.toast = false;
    this.getStepperStatus();
    this.getOrgLeIdList();
  },

  mounted() {
    this.getAllDates();
    this.setGlobalData();
    this.getStepperStatus();
    this.getOrgLeIdList();
  },

  methods: {
    ...mapActions({
      act_update: "onboard/legal_entities/update",
      act_addnew: "onboard/legal_entities/create",
      act_fileUpload: "onboard/file_upload/upload",
      fetchGlobalData: "globalapi/globalData/fetchAll",
      act_fetch_legalEntitiesList: "onboard/legal_entities/fetchAll",
      act_fetch_stepper_status: "onboard/legal_entities/fetchStepperStatus",
      act_changeNavBar: "onboard/legal_entities/updateNavBarState",
      act_change_legalEntity_mode: "onboard/legal_entities/changeEditMode",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    // beforeRouteEnter(to, from, next) {
    //   try {
    //     next(vm => {
    //       vm.activeIndex = vm.$route.params["activeIndex"];
    //       vm.setComponent(vm.activeIndex);
    //       let val = vm.setComponent(vm.activeIndex);
    //     });
    //   } catch (err) {
    //     this.errmsg = err;
    //     this.toast = true;
    //   }
    // },

    /*** PL_2905 */

    getAllDates() {
      try {
        this.startDateOptions = [];
        for (let i = 1; i <= 31; i++) {
          this.startDateOptions.push(i);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    changeDate(event) {
      try {
        this.leData.fbp_lock_btw_from = event;
        //this.leData.fbp_lock_btw_to = event !== 1 ? event - 1 : 31;  // old code comment and new code implementaion below
        this.leData.fbp_lock_btw_to = event !== 1 && event ? event - 1 : event == 1 ? 31 : this.leData.fbp_lock_btw_to;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to validate incorporation date */
    incorporationDateChanged(val) {
      try {
        if (val) {
          if (!(new Date(this.leData.legalActivationDate) >= new Date(val))) {
            this.leData.legalActivationDate = null;
          }
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },
    /*** PL_2905 */

    /* server call to get all legal enities */
    async getLegalEntityList() {
      try {
        let res = await this.act_fetch_legalEntitiesList(this.orgId);
        if (res.data.status) {
          this.legalEntityList = res.data.payload.data;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    async getStepperStatus() {
      try {
        let res = await this.act_fetch_stepper_status({le_id: this.leData.id, index: this.$route.params.entity_index});
        this.disableLogin = res.data.payload.data[0].LegalEntity.login_based_on ? true : false;
        this.disableService = res.data.payload.data[0].LegalEntity.services_availed ? true : false;
        res.data.payload.data[0].LegalEntity.login_based_on == 'email' ? this.leData.loginBasedOnEmail = 'email' : this.leData.loginBasedOnUserName = 'user_name';
        res.data.payload.data[0].LegalEntity.services_availed == 'hcm' ? this.leData.serviceAvailed = 'hcm' : this.leData.serviceAvailed = 'payroll'
        this.$emit("updateIndex", this.$route.params.entity_index);
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to set default value */
    setGlobalData() {
      try {
        this.fetchGlobalRegexValidations();
        this.countriesListArray = config.GlobalList.countriesList;
        let obj = this.globalData;
        this.countryID = this.countriesListArray[0];
        this.headOfficeCountryID = this.countriesListArray[0];
        this.gstCountryID = this.countriesListArray[0];
        this.dispatchCountryID = this.countriesListArray[0];
        this.industrytype = obj
          ? obj.IndustryType
            ? obj.IndustryType
            : []
          : [];
        this.industryTypesArray = obj
          ? obj.IndustryRegistrationType
            ? obj.IndustryRegistrationType
            : []
          : [];
        this.state = obj ? (obj.State ? obj.State : []) : [];
        //  Start PL_2380
        if (this.$route.params.entity_index + 1) {
          this.setLegalEntityData();
        } else {
          this.resetForm();
        }
        // End PL_2380
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to set all configuration from config file */
    fetchGlobalRegexValidations() {
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.phoneNumRegex = config.Regex.PHONE_NUM;
        this.emailRegex = config.Regex.EMAIL;
        this.pincodeRegex = config.Regex.PINCODE;
        this.pancardRegex = config.Regex.LE_PAN;
        this.corporateIdentityRegex = config.Regex.CIN;
        this.taxAccountNumRegex = config.Regex.TAN;
        this.goodsServiceTaxRegex = config.Regex.GST;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },


    /* server call to create or update Legal Entity */
    async save() {
      // add le call with org_id
      this.leData.org_id = this.orgId;
      this.leData.industryTypeID = this.industryTypeID.id;
      this.leData.industryRegTypeID = this.industryRegTypeID.id;
      // Start PL_2380
      this.leData.registeredAddress.stateID = this.stateID
        ? this.stateID.id
        : null;
      this.leData.headOfficeAddress.stateID = this.headOfficeStateID
        ? this.headOfficeStateID.id
        : null;
      this.leData.gstAddress.stateID = this.gstStateID
        ? this.gstStateID.id
        : null;
      this.leData.dispatchAddress.stateID = this.dispatchStateID
        ? this.dispatchStateID.id
        : null;
      this.leData.registeredAddress.cityID = this.cityID
        ? this.cityID.id
        : null;
      this.leData.headOfficeAddress.cityID = this.headOfficeCityID
        ? this.headOfficeCityID.id
        : null;
      this.leData.gstAddress.cityID = this.gstCityID ? this.gstCityID.id : null;
      this.leData.dispatchAddress.cityID = this.dispatchCityID
        ? this.dispatchCityID.id
        : null;
      this.leData.registeredAddress.countryID = this.countryID
        ? this.countryID.id
        : null;
      this.leData.headOfficeAddress.countryID = this.headOfficeCountryID
        ? this.headOfficeCountryID.id
        : null;
      this.leData.gstAddress.countryID = this.gstCountryID
        ? this.gstCountryID.id
        : null;
      this.leData.dispatchAddress.countryID = this.dispatchCountryID
        ? this.dispatchCountryID.id
        : null;
      // End PL_2380
      this.leData.clientCode = this.leData.clientCode.toString().trim();

      // PL_2984
      this.leData.registeredAddress.pincode = this.leData.registeredAddress.pincode ? this.leData.registeredAddress.pincode : null;
      this.leData.headOfficeAddress.pincode = this.leData.headOfficeAddress.pincode ? this.leData.headOfficeAddress.pincode : null;
      this.leData.gstAddress.pincode = this.leData.gstAddress.pincode ? this.leData.gstAddress.pincode : null;
      this.leData.dispatchAddress.pincode = this.leData.dispatchAddress.pincode ? this.leData.dispatchAddress.pincode : null;
      // PL_2984
      this.leData.enable_ctc_report = this.leData ? true: false;
      this.leData.enable_fbp = this.leData.enable_fbp ? true: false;
        this.leData.based_on = this.leData.based_on;
        this.leData.fbp_calculated_on = this.leData.fbp_calculated_on ? this.leData.fbp_calculated_on : "Effective";
        this.leData.fbp_lock_btw_from = this.leData.fbp_lock_btw_from ? this.leData.fbp_lock_btw_from: "";
        this.leData.fbp_lock_btw_to = this.leData.fbp_lock_btw_to ? this.leData.fbp_lock_btw_to: "";
        this.leData.fbp_processed_with_salary = this.leData.fbp_processed_with_salary ? true: false;

      //
      // PL-7143
      this.leData.enable_clear_tax=this.leData&&this.leData.enable_clear_tax?true:false 
      this.leData.enable_political_party_component=this.leData&&this.leData.enable_political_party_component?true:false 
      this.leData.is_arrears_separate = this.leData.is_arrears_separate ? true : false;
      this.leData.login_based_on = this.leData.loginBasedOnEmail == 'email' ? 'email' : 'user_name';
      this.leData.services_availed = this.leData.serviceAvailed == 'hcm' ? 'hcm' : 'payroll';

      if (!this.leData.autogenerate_employee_code) {
        this.leData.suffix = null;
        this.leData.prefix = null;
        this.leData.length = null;
        this.leData.number = null;
      }
      try {
        if (this.editForm || this.editMode) {
          this.leData.employee_code_format = {
            length: this.leData.length,
            number: this.leData.number,
            prefix: this.leData.prefix,
            suffix: this.leData.suffix
          };
          this.leData.legalName = this.leData.legalName.toString().trim();
          this.leData.logoURL = this.cropped;
          this.$root._data.isSaving = true;

          let res = await this.act_update({
            data: this.leData
          });
          setTimeout(() => {
            if (res.data.status) {
              this.popupTitle = res.data.message;
              this.showpopup = true;
            }

            this.$root._data.isSaving = false;
          }, 500);
        } else {
          this.leData.employee_code_format = {
            length: this.leData.length,
            number: this.leData.number,
            prefix: this.leData.prefix,
            suffix: this.leData.suffix
          };
          this.leData.legalName = this.leData.legalName.toString().trim();
          this.leData.logoURL = this.cropped;
          this.$root._data.isSaving = true;
          let res = await this.act_addnew({
            data: this.leData
          });
          setTimeout(() => {
            if (res.data.status) {
              this.newlyCreatedLegalEntityID = res.data.payload.id;
              this.popupTitle = res.data.message;
              this.showpopup = true;
            }
            this.$root._data.isSaving = false;
          }, 500);

        }
        this.getLegalEntityList(this.orgId);
        this.$validator.reset();
      } catch (err) {
        this.$root._data.isSaving = false;
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to set legal entity data into model */
    setLegalEntityData() {
      try {
        if (this.$route.params.entity_index + 1) {
          this.editMode = true;
          let Obj = this.legalEntityData[this.$route.params.entity_index];
          this.leData.legalName = Obj.legalName;
          this.cropped = Obj.logoURL;
          this.leData.clientCode = Obj.clientCode.toString().trim();
          if(this.leData && this.leData.clientCode){
            this.client_code_exist = true;
          } else{
            this.client_code_exist = false;
          }
          this.leData.incorporationDate = Obj.incorporationDate;
          this.leData.legalActivationDate = Obj.legalActivationDate;
          this.leData.registeredAddress = Obj.registeredAddress;
          this.leData.isSameAsDispatchAddress = Obj.isSameAsDispatchAddress;
          this.leData.GSTNumber = Obj.GSTNumber;
          this.leData.CINNumber = Obj.CINNumber;
          this.leData.TANNumber = Obj.TANNumber;
          this.leData.PANNumber = Obj.PANNumber;
          this.leData.TANCircle = Obj.TANCircle;
          this.leData.org_id = Obj.org_id;
          this.leData.id = Obj.id;
          this.leData.enable_fbp = Obj.enable_fbp ? true: false;
          this.leData.enable_ctc_report = Obj.enable_ctc_report ? true : false;
          if (Obj.enable_fbp) {
            this.leData.based_on = Obj.based_on;
            this.leData.fbp_calculated_on = Obj.fbp_calculated_on
            this.leData.fbp_lock_btw_from = Obj.fbp_lock_btw_from;
            this.leData.fbp_lock_btw_to = Obj.fbp_lock_btw_to;
            this.leData.fbp_processed_with_salary = Obj.fbp_processed_with_salary ? true: false;
            this.leData.fbp_settlement_type = Obj.fbp_settlement_type;
          }

          // PL_2380
          this.stateID = this.state.find(
            item => item.id == Obj.registeredAddress.stateID
          );
          if (this.leData.registeredAddress.cityID) {
            this.cityID = this.stateID.City.find(
              item => item.id == this.leData.registeredAddress.cityID
            );
          }
          this.countryID = this.countriesListArray[0];
          this.headOfficeCountryID = this.countriesListArray[0];
          this.gstCountryID = this.countriesListArray[0];
          this.dispatchCountryID = this.countriesListArray[0];

          this.leData.isSameAsHeadAddress = Obj.isSameAsHeadAddress;
          this.leData.isSameAsGstAddress = Obj.isSameAsGstAddress;
          if (this.leData.isSameAsHeadAddress) {
            this.leData.headOfficeAddress = this.leData.registeredAddress;
            this.headOfficeStateID = this.stateID;
            this.headOfficeAddressDisable=true;
          } else {
            this.leData.headOfficeAddress = Obj.headOfficeAddress;
             this.headOfficeAddressDisable=true;
            // PL_2380
            this.headOfficeStateID = this.state.find(
              item => item.id == Obj.headOfficeAddress.stateID
            );
          }
          if (this.leData.headOfficeAddress.cityID) {
            this.headOfficeCityID = this.headOfficeStateID.City.find(
              item => item.id == this.leData.headOfficeAddress.cityID
            );
          }
          if (this.leData.isSameAsGstAddress) {
            this.leData.gstAddress = this.leData.registeredAddress;
            this.gstStateID = this.stateID;
            this.gstAddressDisable=true;
          } else {
            this.leData.gstAddress = Obj.gstAddress;
            this.gstAddressDisable=false;
            // PL_2380
            this.gstStateID = this.state.find(
              item => item.id == Obj.gstAddress.stateID
            );
          }
          if (this.leData.gstAddress.cityID) {
            this.gstCityID = this.gstStateID.City.find(
              item => item.id == this.leData.gstAddress.cityID
            );
          }
          if (this.leData.isSameAsDispatchAddress) {
            this.leData.dispatchAddress = this.leData.registeredAddress;
            this.dispatchStateID = this.stateID;
            this.dispatchAddressDisable=true;
          } else {
            this.leData.dispatchAddress = Obj.dispatchAddress;
            this.dispatchAddressDisable=false;
            // PL_2380
            this.dispatchStateID = this.state.find(
              item => item.id == Obj.dispatchAddress.stateID
            );
          }
          if (this.leData.dispatchAddress.cityID) {
            this.dispatchCityID = this.dispatchStateID.City.find(
              item => item.id == this.leData.dispatchAddress.cityID
            );
          }
          this.leData.autogenerate_employee_code =
            Obj.autogenerate_employee_code;
          this.leData.industryTypeID = Obj.IndustryType;
          this.leData.industryRegTypeID = Obj.IndustryRegistrationType;
          this.industryRegTypeID = Obj.IndustryRegistrationType
            ? Obj.IndustryRegistrationType
            : null;
          this.industryTypeID = Obj.IndustryType ? Obj.IndustryType : null;

          this.leData.contactDetails = Obj.OrganisationContactDetails.length
            ? Obj.OrganisationContactDetails[0].contactDetails
            : [{ name: "", phoneNumber: "", email: "", remarks: "" }];
          if (Obj.autogenerate_employee_code) {
            this.leData.suffix = Obj.employee_code_format.suffix
              ? Obj.employee_code_format.suffix
              : "";
            this.leData.prefix = Obj.employee_code_format.prefix
              ? Obj.employee_code_format.prefix
              : "";
            this.leData.length = Obj.employee_code_format.length;
            this.leData.number = Obj.employee_code_format.number
              ? Obj.employee_code_format.number
              : "";
            this.leData.status = Obj.employee_code_format.status;
            this.showPreview = true;
            this.finalCode =
              this.leData.prefix + this.leData.number + this.leData.suffix;
          } else {
            this.leData.suffix = ""; // PL_2895
            this.leData.prefix = ""; // PL_2895
            this.leData.length = ""; // PL_2895
            this.leData.number = ""; // PL_2895
            this.finalCode = ""; // PL_2895
          }
          this.showPreview =
            this.finalCode != "" && this.finalCode != null ? true : false;
          this.leData.logoURL = this.cropped; // PL_2895
          this.leData.enable_clear_tax=Obj.enable_clear_tax; // PL7143
          this.leData.enable_political_party_component=Obj.enable_political_party_component;
          this.leData.is_arrears_separate = Obj.is_arrears_separate ? true : false;
        } else {
          this.leData.contactDetails = [
            { name: "", phoneNumber: "", email: "", remarks: "" }
          ];
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to delete legal entity logo */
    deleteLogo() {
      this.cropped = "";
    },

    /* function to generate and update the employee code format */
    updateEmployeeCode() {
      try {
        if (
          this.leData.length &&
          ((this.leData.prefix && this.leData.number) || this.leData.suffix)
        ) {
          this.showPreview = true;
          let codeString =
            this.leData.prefix +
            Number(this.leData.number) +
            this.leData.suffix;
          let stringNumber = Number(this.leData.number);
          // PL_2895
          if (codeString.length < Number(this.leData.length)) {
            for (
              let i = 0;
              i < Number(this.leData.length) - codeString.length;
              i++
            ) {
              stringNumber = "0" + stringNumber;
            }
          }
          this.leData.number = stringNumber;
          this.finalCode =
            this.leData.prefix + this.leData.number + this.leData.suffix;
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to validate form */
    submitLegalEntity() {
      try {
        this.$validator.validateAll().then(result => {
          if (result) {
            if (this.leData.autogenerate_employee_code) {
              if (
                (this.leData.prefix + this.leData.number + this.leData.suffix)
                  .length > Number(this.leData.length)
              ) {
                this.toast = true;
                this.errmsg =
                  "The length of employee code should be equal to given length for code!";
              } else {
                this.toast = false;
                this.save();
              }
            } else if(!this.leData.loginBasedOnEmail && !this.leData.loginBasedOnUserName) {
              this.toast = true;
              this.errmsg =
              "Select user name or email for login";
            } else if(!this.leData.serviceAvailed) {
              this.toast = true;
              this.errmsg =
              "Select Services Availed";
            }else {
              this.toast = false;
              this.save();
            }
          } else {
            // to navigate to error fields(PL- 1872) - 28/11/2019
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
              });
          }
        });
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to go to summary page */
    goToOrgSummary() {
      try {
        this.showpopup = false;
        this.$validator.reset();
        this.$router.push({ path: "/orgsummary" });
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to hide the success pop-up and to navigate next page */
    continueToLocations() {
      try {
        this.showpopup = false;
        this.$validator.reset();
        if (this.editForm || this.editMode) {
          this.$router.push({
            path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
          });
        } else {
          this.changeLegalEntityMode();
          let le_index = -1;
          this.legalEntityList.forEach((data, index) => {
            if (data.id == this.newlyCreatedLegalEntityID) {
              le_index = index;
            }
          });
          if (le_index > -1) {
            this.$router.push({
              path: `/onboarding/entity/${le_index}/locations`
            });
          }
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to change the mode edit or create */
    async changeLegalEntityMode() {
      try {
        await this.act_change_legalEntity_mode(true);
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to get file url after edit and upload to the server */
    getFile(event) {
      try {
        this.cropped = event.data.location;
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to copy the address if same as registered address check box checked */
    mapAddress(type) {
      try {
        switch (type) {
          case "gst":
            if (this.leData.isSameAsGstAddress) {
              this.leData.gstAddress = this.leData.registeredAddress;
              this.gstStateID = this.stateID;
              this.gstCityID = this.cityID;
              this.gstAddressDisable=true;
            } else {
              this.gstStateID = null;
              this.gstCityID = null;
              this.gstAddressDisable=false;
              this.leData.gstAddress = {
                addressLineOne: "",
                addressLineTwo: "",
                pincode: null,
                email: "",
                phoneNumber: "",
                countryID: this.countriesListArray[0],
                cityID: null,
                stateID: null
              };
            }
            break;
          case "headoffice":
            if (this.leData.isSameAsHeadAddress) {
              this.leData.headOfficeAddress = this.leData.registeredAddress;
              this.headOfficeStateID = this.stateID;
              this.headOfficeCityID = this.cityID;
              this.headOfficeAddressDisable=true;
            } else {
              this.headOfficeStateID = null;
              this.headOfficeCityID = null;
              this.headOfficeAddressDisable=false;
              this.leData.headOfficeAddress = {
                addressLineOne: "",
                addressLineTwo: "",
                pincode: null,
                email: "",
                phoneNumber: "",
                countryID: this.countriesListArray[0],
                cityID: null,
                stateID: null,


              };

            }
            break;
          default:
            if (this.leData.isSameAsDispatchAddress) {
              this.leData.dispatchAddress = this.leData.gstAddress;
              this.dispatchStateID = this.stateID;
              this.dispatchCityID = this.cityID;
              this.dispatchAddressDisable=true;
            } else {
              this.dispatchStateID = null;
              this.dispatchCityID = null;
              this.dispatchAddressDisable=false;
              this.leData.dispatchAddress = {
                addressLineOne: "",
                addressLineTwo: "",
                pincode: null,
                email: "",
                phoneNumber: "",
                countryID: this.countriesListArray[0],
                cityID: null,
                stateID: null
              };
            }
            break;
        }
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },


    /* function to reset the form */
    resetForm() {
      try {
        this.countryID = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;
        this.headOfficeCountryID = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;
        this.gstCountryID = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;
        this.dispatchCountryID = this.countriesListArray[0]
          ? this.countriesListArray[0]
          : null;

        this.stateID = null;
        this.headOfficeStateID = null;
        this.gstStateID = null;
        this.dispatchStateID = null;
        this.industryTypeID = null;
        this.industryRegTypeID = null;
        this.cityID = null;
        this.headOfficeCityID = null;
        this.gstCityID = null;
        this.headOfficeCityID = null;
        this.finalCode = "";
        this.leData = {
          org_id: "",
          legalName: "",
          industryTypeID: null,
          industryRegTypeID: null,
          logoURL: "",
          isSameAsHeadAddress: false,
          isSameAsDispatchAddress: false,
          autogenerate_employee_code: false,
          isSameAsGstAddress: false,
          registeredAddress: {
            addressLineOne: "",
            addressLineTwo: "",
            pincode: null,
            phoneNumber: null,
            countryID: this.countriesListArray[0]
              ? this.countriesListArray[0]
              : null,
            cityID: null,
            stateID: null,
            email: null
          },
          headOfficeAddress: {
            addressLineOne: "",
            addressLineTwo: "",
            pincode: null,
            phoneNumber: null,
            countryID: this.countriesListArray[0]
              ? this.countriesListArray[0]
              : null,
            cityID: null,
            stateID: null,
            email: null
          },
          gstAddress: {
            addressLineOne: "",
            addressLineTwo: "",
            pincode: null,
            phoneNumber: null,
            countryID: this.countriesListArray[0]
              ? this.countriesListArray[0]
              : null,
            cityID: null,
            stateID: null,
            email: null
          },
          dispatchAddress: {
            addressLineOne: "",
            addressLineTwo: "",
            pincode: null,
            phoneNumber: null,
            countryID: this.countriesListArray[0]
              ? this.countriesListArray[0]
              : null,
            cityID: null,
            stateID: null,
            email: null
          },
          LEactivationDate: "",
          incorporationDate: "",
          clientCode: "",
          contactDetails: [
            { name: "", phoneNumber: "", email: "", remarks: "" }
          ],
          TANNumber: "",
          PANNumber: "",
          TANCircle: "",
          GSTNumber: "",
          status: "",
          prefix: "",
          suffix: "",
          password_policy: null,
          length: "", // PL_2895
          number: "", // PL_2895
          enable_fbp: false,
          enable_ctc_report: false,
          based_on: "CTC",
          fbp_calculated_on: "",
          fbp_lock_btw_from: 1,
          fbp_lock_btw_to: 31,
          fbp_processed_with_salary: true,
          fbp_settlement_type: 'Yearly'
        };
        this.$validator.reset();
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to add new row to add new contact info */
    addlevel() {
      try {
        this.leData.contactDetails.push({
          name: "",
          phoneNumber: "",
          email: null,
          remarks: ""
        });
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to delete the row */
    deleteLevel(index) {
      try {
        this.leData.contactDetails.splice(index, 1);
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/locations`
      });
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.legalEntityInfoValue = data.data.user.permissions.legal_entity_info ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.errorMessage {
  color: #e01717;
  .error {
    margin-top: 2px;
  }
}

.point-events-none{
  pointer-events: none;
}

.label {
  font-family: Montserrat;
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  display: flex;
  flex-direction: column;
}
.spanlabel {
  margin-bottom: 5px;
}
.samecheck {
  align-self: center;
  color: #6e6e6e;
}
.delete-level {
  color: #5d409f;
  font-weight: 600;
}
.main-container {
  margin-bottom: 300px;
}
.delete {
  padding-top: 25px;
}
.center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.code-preview {   //  PL_2948
  background-color: #f9f9f9;
  width: 300px;
  display: flex;
  padding: 20px 30px;
}
.danger {
  color: #e01717;
  font-size: 12px;
  padding-top: 5px !important;
  display: inline-block;
  .imgClass {
    padding-top: 0px;
    float: left;
    margin-right: 5px;
  }
}
.customwidth {
  width: 300px;
  margin-right: 32px;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
